export enum ErrorTitle {
  NOTIFICATION_401_403 = 'NOTIFICATION_401_403'
}
